import { MessageDescriptor, defineMessages } from 'react-intl';
import { Music24PlanTier } from 'fym-common/src/license/music24Plans';

/**
 * The name and one-line description of each plan tier. Static `defineMessages`, not the plain
 * `Music24Plan.nameMessageId`/`nameDefault` data, because `pnpm trans` extracts only literal ids.
 * The plans window, its compare table and the upgrade prompt all read these.
 */
const planMessages = defineMessages({
  freeName: { id: 'app.sml.pricing.plan.free.name', defaultMessage: 'Free' },
  freeDescription: {
    id: 'app.sml.pricing.plan.free.description',
    defaultMessage: 'Try MUSIC24 with your first release.',
  },
  trialName: { id: 'app.sml.pricing.plan.trial.name', defaultMessage: 'Trial' },
  artistName: { id: 'app.sml.pricing.plan.artist.name', defaultMessage: 'Plus' },
  artistDescription: {
    id: 'app.sml.pricing.plan.artist.description',
    defaultMessage: 'For an artist who releases often.',
  },
  proName: { id: 'app.sml.pricing.plan.pro.name', defaultMessage: 'Pro' },
  proDescription: {
    id: 'app.sml.pricing.plan.pro.description',
    defaultMessage: 'Full-song videos, AI clips and your own domain.',
  },
  plugName: { id: 'app.sml.pricing.plan.plug.name', defaultMessage: 'Plug' },
  plugDescription: {
    id: 'app.sml.pricing.plan.plug.description',
    defaultMessage: 'Pitch every release to the playlists and blogs that fit.',
  },
  managerName: { id: 'app.sml.pricing.plan.manager.name', defaultMessage: 'Max' },
  managerDescription: {
    id: 'app.sml.pricing.plan.manager.description',
    defaultMessage: 'More posts, more video credits and API access.',
  },
  labelName: { id: 'app.sml.pricing.plan.label.name', defaultMessage: 'Ultra' },
  labelDescription: {
    id: 'app.sml.pricing.plan.label.description',
    defaultMessage: 'The highest limits, Autopilot pitching and API access.',
  },
});

export const planNameMessages: Record<Music24PlanTier, MessageDescriptor> = {
  free: planMessages.freeName,
  trial: planMessages.trialName,
  artist: planMessages.artistName,
  pro: planMessages.proName,
  plug: planMessages.plugName,
  manager: planMessages.managerName,
  label: planMessages.labelName,
};

/** `trial` is not sold and has no card, so it has no description. */
export const planDescriptionMessages: Record<Exclude<Music24PlanTier, 'trial'>, MessageDescriptor> = {
  free: planMessages.freeDescription,
  artist: planMessages.artistDescription,
  pro: planMessages.proDescription,
  plug: planMessages.plugDescription,
  manager: planMessages.managerDescription,
  label: planMessages.labelDescription,
};
